/*
 * 自动清理localStorage
 * 背景：QQMap在localStorage缓存了js和css，导致localStorage存储超出上限，用户无法登录
 * QQMap相关功能已下线
 * */

// 智齿 /_(first(Url|Title)|ref)$/ 暂不处理

const QQMAP_KEYS = ['styles', 'style_version', /^QMAPI/]

const match = (key, keys) => {
    return keys.some(v => {
        if (Object.prototype.toString.call(v) === '[object RegExp]') {
            return v.test(key)
        }

        return v === key
    })
}

// 清理无用的localStorage数据
export const autoClearLocalStorageUnusedData = () => {
    try {
        for (let item in localStorage) {
            if (localStorage.hasOwnProperty(item)) {
                const isMatched = match(item, QQMAP_KEYS)

                if (isMatched) {
                    localStorage.removeItem(item)
                }
            }
        }
    } catch (e) {
        console.error('catchError', e)
    }
}
